import React from 'react';
import type {BookingSummary, GuestGroup, Housing} from '@chekin/core';

export type TaxesEnv = {
  isTokenValid: boolean;
  reservationId?: string;
  housing?: Housing;
  summary?: BookingSummary;
  guestGroup?: GuestGroup;
  areAllGuestsRegistered: boolean;
  privacyPolicy?: {href?: string; isCustomDocument?: boolean; isLoading?: boolean};
};

export const TaxesEnvContext = React.createContext<TaxesEnv>({
  isTokenValid: false,
  areAllGuestsRegistered: false,
});

export function useTaxesEnv() {
  return React.useContext(TaxesEnvContext);
}
